import { cx } from "class-variance-authority";
import DateTime from "@/components/datetime";
import { getHumanizedFromToday } from "@/components/utils/getHumanizedFromToday";
import { HorizontalList } from "@/components/horizontal-list/horizontal-list";
import { PublicCandidateJobAppNode } from "modules/graphql.types";
import { APP_STATUS } from "../app-status-badge";

const EMPTY_ARRAY = [];

export const JobCard = (props: {
  title: string;
  openDate: Date;
  jobApp: PublicCandidateJobAppNode;
  onClick: () => void;
  details: React.ReactNode[];
}) => {
  return (
    <li
      role="menuitem"
      tabIndex={0}
      data-test-class="job-card"
      onClick={props.onClick}
      onKeyUp={(e) => {
        if (e.key === "Enter") {
          props.onClick();
        }
      }}
      className={cx(
        "flex flex-col px-6 py-5",
        "border-dublin-gray border bg-white",
        "rounded-md",
        "gap-y-2",
        "hover:shadow-md",
        "transition-all",
        props.onClick ? "cursor-pointer" : "cursor-default",
      )}
    >
      <div className="flex items-center justify-between gap-x-4">
        <span
          data-test-class="job-card-title"
          className="text-charcoal truncate text-xl font-medium"
        >
          {props.title}
        </span>
        <DateTime
          format={getHumanizedFromToday}
          date={props.openDate}
          className="text-macbook whitespace-nowrap text-sm"
          data-test-class="job-card-open-date"
        />
      </div>

      <div className="grid grid-cols-[1fr,auto] items-center justify-between">
        <HorizontalList
          ariaLabel="Job details"
          itemClass="text-sm text-medium-hippo"
          items={props.details ?? EMPTY_ARRAY}
        />
        {APP_STATUS[
          props.jobApp?.isComplete && props.jobApp?.creationType !== "MANUAL"
            ? "APPLIED"
            : props.jobApp?.creationType === "MANUAL" ||
              (props.jobApp && !props.jobApp?.isComplete)
            ? "INFO_PENDING"
            : "UNDEFINED"
        ]()}
      </div>
    </li>
  );
};
